import { render, staticRenderFns } from "./notecontent.html?vue&type=template&id=647cb986&scoped=true&"
import script from "./notecontent.js?vue&type=script&lang=js&"
export * from "./notecontent.js?vue&type=script&lang=js&"
import style0 from "./notecontent.sass?vue&type=style&index=0&id=647cb986&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647cb986",
  null
  
)

component.options.__file = "notecontent.vue"
export default component.exports